import axios from "axios";

/**
 * LF360-1953 — where the `/app/*` landing page should send somebody.
 *
 * Public: it is asked before any sign-in, by a page that is public itself, and
 * it carries nothing secret — the web app's address is in every reminder email
 * already.
 *
 * Deliberately not through the usual interceptor's expectations: this is asked
 * on a page where there is no session, and a 401 anywhere in the app would be
 * the wrong reading of it. The endpoint answers 200 either way, with `null`
 * where an environment has no web app.
 */
const getConfig = () => axios.get("api/v1/app-link/config");

const ApiAppLink = {
  getConfig,
};

export default ApiAppLink;
